import {
    infoMethod,
    InfoMethodResponse,
    ServiceResponseData,
} from 'service/Authorization/infoMethod';

/**
 * @description AuthorizationService.
 */
export class AuthorizationService {
    /**
     * @description Api method info.
     * @returns {Promise} - Return of info Method.
     */
    static async info(): Promise<ServiceResponseData<InfoMethodResponse>> {
        // return authorizationServiceWithMockData.info();
        return infoMethod();
    }
}
